<div class="activity-card" [ngClass]="getAccentClass()">
  @if (loading) {
    <div class="loading-state">
      <div class="skeleton skeleton-icon"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-subtext"></div>
    </div>
  } @else {
    <div class="card-icon">
      <app-icon [type]="icon" [size]="24"></app-icon>
    </div>

    <div class="card-content">
      <h3 class="card-title">{{ title }}</h3>
      @if (count > 0) {
        <p class="card-count">
          <span class="count-number">{{ count }}</span>
          <span class="count-label">{{ subtitle }}</span>
        </p>
      } @else {
        <p class="empty-message">{{ emptyMessage }}</p>
      }
    </div>

    <button class="btn btn-tertiary action-btn" (click)="onAction()">
      {{ actionLabel }}
      <app-icon [type]="IconType.CHEVRON_RIGHT" [size]="16"></app-icon>
    </button>
  }
</div>
